export default {
  getTwilioNumber: (state) => state.twilioNumber,
};
